import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './AddLeave.css';
import TauriLoader2 from '../../TauriLoader2/TauriLoader2';
import TauriImage from '../../TauriImage/TauriImage';
import appURL from '../../../appURL.json';
import { transformActivities, transformLeaveTypes } from '../PlanningFactoryData/PlanningFactoryData';
import { getAll, getRecordById, syncDataToLocal } from '../../../localDB';
import { activityClassification, eventTypes } from '../../../visualizations/visualizations';

const AddLeave = ({ show, onHide, worksheet, selectedDate, isCreating, onAdd }) => {
    const [leavetypes, setLeaveTypes] = useState([]);
    const [selectedLeaveType, setSelectedLeaveType] = useState(null);
    const [notes, setNotes] = useState("");

    const formattedDate = new Date(selectedDate).toLocaleDateString("en-US", {
        weekday: "long",   // Wednesday
        month: "short",    // Aug
        day: "numeric",    // 19
        year: "numeric",   // 2025
    });

    const handleProceed = () => {
        if (!onAdd) return;

        const payload = {
            Date: selectedDate ? selectedDate.toLocaleDateString("en-CA") : null,
            ReferenceID: selectedLeaveType?.ID,
            Description: selectedLeaveType?.Name,
            Remarks: notes
        };

        onAdd(payload);
    };

    const fetchOnlineActivities = async () => {
        try {
            const token = localStorage.getItem("token");
            const devId = localStorage.getItem("devId");
            const response = await fetch(`${appURL.API_LeaveTypes}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'X-ETR-Device-ID': devId
                }
            });

            if (!response.ok) {
                console.log("Failed to fetch leave!");
                return;
            }

            const data = await response.json();

            const filteredLeaveTypes = (data.leaveTypes || []).filter(
                leave => leave.code !== "SL"
            );

            const transformLeave = await transformLeaveTypes(filteredLeaveTypes);

            if (transformLeave) syncDataToLocal('LeaveTypes', transformLeave);
            setLeaveTypes(transformLeave);
            if (transformLeave.length > 0) {
                setSelectedLeaveType(transformLeave[0]);
            }
        } catch (err) {
            console.log(err);
        }
    }

    const fetchOfflineActivities = async () => {
        try {
            const leaveType = await getAll("LeaveTypes");
            const filterLeaveType = leaveType.filter(a => a.Code !== "SL");
            setLeaveTypes(filterLeaveType);
        } catch (err) {
            console.log(err);
        }
    }

    const fetchData = async () => {
        const isOnline = JSON.parse(localStorage.getItem("isOnline"));
        const hasInternet = navigator.onLine;

        if (isOnline && hasInternet) {
            await fetchOnlineActivities();
        } else {
            await fetchOfflineActivities();
        }
    }

    const checkEvent = async () => {
        if (worksheet?.Days && selectedDate) {
            const dateKey = new Date(selectedDate).toLocaleDateString("en-CA");
            const dayData = worksheet.Days[dateKey];

            if (dayData?.event && dayData.event.type === eventTypes.Leave) {
                const leave = await getRecordById("LeaveTypes", dayData.event?.referenceID);
                setNotes(dayData.event?.remarks);
                setSelectedLeaveType(leave);
                return true;
            }
        }
        return false;
    }

    useEffect(() => {
        const initialize = async () => {
            await fetchData();
            setNotes("");

            const eventFound = await checkEvent();
            if (!eventFound && leavetypes.length > 0) {
                setSelectedLeaveType(leavetypes[0]);
            }
        };

        initialize();
    }, [show, selectedDate, worksheet]);

    return (
        <Modal
            className='add-leavetype-modal'
            show={show}
            onHide={onHide}
            size="lg"
            centered
            backdrop={isCreating ? "static" : true}
            keyboard={!isCreating}
        >
            <Modal.Header>
                Add Leave
            </Modal.Header>
            <Modal.Body>
                <div className="schedule-options">
                    <div className="schedule-date d-flex align-items-center">
                        <TauriImage
                            localImage={"/Images/circle-check.svg"}
                            alt="icon"
                            className={"me-2"}
                        />
                        <span>{formattedDate}</span>
                    </div>

                    <div className="activity-options">
                        {leavetypes.map((activity) => (
                            <label key={activity.ID}>
                                <input
                                    type="radio"
                                    name="activity"
                                    value={activity.ID}
                                    checked={selectedLeaveType?.ID === activity.ID}
                                    onChange={() => setSelectedLeaveType(activity)}
                                />
                                {activity.Name}
                            </label>
                        ))}
                    </div>

                    <div className='mb-3'>
                        <div className='mb-1'>Notes</div>
                        <textarea
                            id="notes"
                            className="form-control"
                            rows={3}
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-end">
                <Button className='btn-proceed d-flex align-items-center' disabled={isCreating} onClick={handleProceed}>
                    {isCreating && (
                        <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#1D5D9B" />
                    )}
                    <span className="text-nowrap">Proceed</span>
                </Button>
                <Button className="btn-cancel d-flex" disabled={isCreating} onClick={onHide}>
                    <span className="text-nowrap">Cancel</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddLeave;
